import axios from 'axios';

/**
 * Importation des différentes sous-api
 */
import wordpress from './wordpress';
import acf from './acf';
import kookvue from './kookvue';

/**
 * Un query builder simple pour des requêtes GET sur l'API REST de WordPress
 */
class WPRequest {
	/**
	 * Crée un nouveau query builder
	 *
	 * @constructor
	 *
	 * @param {String} url
	 *      Le path vers l'API à utiliser
	 */
	constructor(url) {
		this.url = url;
		this.routeparams = [];
		this.errors = [];
		this.params = [];

		this.valid = true;
	}

	/**
	 * Modifie l'endpoint de l'API ciblé par la requête
	 * Possibilité de définir des paramètres qui seront bindés ensuite grâce au caractère ":"
	 * Les paramètres non bindés à l'execution de la requête ne seront simplement ignorés
	 * ex :
	 * get("posts/:id/:name")
	 *
	 *
	 * @param {String} route
	 */
	get(route) {
		this.routeparams = route.split('/');
		return this;
	}

	/**
	 * Attribue une valeur à un paramètre d'url défini dans la route
	 * ex:
	 * get("posts/:id").bind("id", 1)
	 *    donne "posts/1"
	 *
	 * @param {*} name
	 * @param {*} value
	 */
	bind(name, value) {
		let i = this.routeparams.indexOf(`:${name}`);
		if (i >= 0) {
			this.routeparams[i] = `${value}`;
		}

		return this;
	}

	/**
	 * Attribue une valeur à un paramètre d'url défini dans la route si une condition est respectée
	 * Si la condition n'est pas vérifiée,
	 *
	 * @param {*} condition
	 * @param {*} name
	 * @param {*} value
	 */
	ifbind(condition, name, value) {
		if (condition) {
			this.bind(name, value);
		}
		return this;
	}

	/**
	 * Ajoute une condition à la validité de la requête
	 *
	 * @param {boolean} condition
	 * @param {error} error
	 *    L'erreur à afficher si la condition n'est pas respectée
	 */
	assert(condition, error) {
		if (this.valid && !condition) {
			this.errors.push(error);
		}
		this.valid = this.valid && condition;
		return this;
	}

	/**
	 * Ajoute un paramètre dans le queryString de la requête
	 *
	 * @param {String} name
	 *    Le nom du paramètre
	 *
	 * @param {*} value
	 *    La valeur du paramètre
	 */
	param(name, value) {
		this.params.push(`${name}=${value}`);
		return this;
	}

	/**
	 * Ajoute un paramètre dans le queryString de la requête sous une certaine condition
	 *
	 * @param {boolean} condition
	 *    La condition à laquelle le paramètre est ajouté au queryString
	 *
	 * @param {String} name
	 *    Le nom du paramètre
	 *
	 * @param {*} value
	 *    La valeur du paramètre
	 */
	ifparam(condition, name, value) {
		if (condition) this.param(name, value);
		return this;
	}

	/**
	 * Construit et execute la requête puis retourne une promesse sur la réponse de l'API
	 */
	execute() {
		return new Promise((resolve, reject) => {
			if (!this.valid) reject(this.errors);

			// build the full url from url and params
			let full = this.url;

			let route = this.routeparams.filter((p) => p && !p.startsWith(':')).join('/');
			full += route;

			let queryString = this.params.join('&');
			if (this.params.length) {
				full += '?' + queryString;
			}

			let headers = {};

			if(WP.__NONCE__ !== undefined){
				headers['X-WP-Nonce'] = WP.__NONCE__;
			}

			// send request
			axios
				.get(full, {'headers' :headers})
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
}

export default {
	WPRequest,
	...wordpress, // commandes liées à l'API native de Wordpress
	...acf, // commandes liées à l'API gérant les champs ACF de Wordpress
	...kookvue, // commandes liées aux endpoints personnalisés
};



// WEBPACK FOOTER //
// ./src/api/api.js